export { RemoveEid as RemoveEidModal } from './RemoveEid';
